import React from 'react'
// import Navtop from '../Topnavbar/Navtop';
import Footer from '../Footer/Footer';
import Products from '../Pages/Products';
import Popicon from '../Components/Popicon';
import Header from '../Header/Header';




export default function Companymemo() {
  return (
    <div>
          <Header />
          <Popicon />
          <div className="space-for-top" style={{ marginTop: '10rem' }}>
              <Products />

          </div>

          <Footer />
    </div>
  )
}
